import { ValidatorBase } from './ValidatorBase'
import { StringUtils } from '../../../Utils/StringUtils';

export class UrlValidator extends ValidatorBase {

    public constructor(message: string, data: string) {
        super(message, data);
    }

    public validate(value: string, messages: string[]) {
        var regex = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        if (!regex.test(value)) {
            let msg = StringUtils.isNullOrEmpty(this._message) ? "Value is not a valid URL." : this._message;
            messages.push(msg);
        }
    }

}


/** WEBPACK FOOTER **
 ** ./Typescript/Components/ConfigurationPanel/Validators/UrlValidator.ts
 **/